import { useMemo } from 'react';

import { expValEquals } from '@confluence/feature-experiments';

import { handleEditorBreadcrumbsQueryResult } from './handleEditorBreadcrumbsQueryResult';
import { useExperimentalEditorBreadcrumbsQuery } from './useExperimentalEditorBreadcrumbsQuery';
import type { EditorBreadcrumbsQueryVariables } from './__types__/EditorBreadcrumbsQuery';

export type BreadcrumbsType = Array<{
	url: string | null;
	title: string;
}>;

export function useEditorBreadcrumbs(
	contentId?: EditorBreadcrumbsQueryVariables['contentId'],
): BreadcrumbsType {
	const queryArgs = {
		variables: {
			contentId: contentId!,
		},
		skip: !contentId, // The template editor does not carry a contentId.
	};

	const { data, error } = useExperimentalEditorBreadcrumbsQuery(queryArgs);

	const breadcrumbs = handleEditorBreadcrumbsQueryResult(data, error);

	const memoizedBreadcrumbs = useMemo(() => {
		return handleEditorBreadcrumbsQueryResult(data, error);
	}, [data, error]);

	return expValEquals('confluence_edit_page_rerender_optimizations', 'isEnabled', true)
		? memoizedBreadcrumbs
		: breadcrumbs;
}
